<script lang="ts">
    import type {CodebookValueFilterableDatatype, GenericDatatypedFilterDefinition} from '../../types';
    import DatatypeValueEditor from './DatatypeValueEditor.svelte';

    export let valueFilterDefinition: GenericDatatypedFilterDefinition<CodebookValueFilterableDatatype>;
</script>

<DatatypeValueEditor filterableDatatypeDefinition={valueFilterDefinition}/>